import type { Components } from '@/api/generated/api';
import { i18n } from '@/i18n/translations';

const FILE_SCAN_ERROR_KEYS: Partial<Record<Components.Schemas.FileMalwareScanStatus, string>> = {
  pending: 'fileScan.pending',
  threatsFound: 'fileScan.threatsFound',
  unsupported: 'fileScan.unsupported',
  accessDenied: 'fileScan.accessDenied',
  failed: 'fileScan.failed',
  unavailable: 'fileScan.unavailable',
};

/** A known file restriction with a message the shared toast handler can safely display. */
export class FileScanError extends Error {
  public readonly translationKey: string;

  constructor(status: Components.Schemas.FileMalwareScanStatus) {
    const translationKey = FILE_SCAN_ERROR_KEYS[status] ?? 'fileScan.unavailable';
    super(i18n.global.t(translationKey));
    this.translationKey = translationKey;
  }
}
